module.exports = __webpack_public_path__ + "kaci-baum-2.jpg?e06d84cb846db2a463ac3d904ac0c362";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/kaci-baum-2.jpg
// module id = 239
// module chunks = 0